import React from "react";
import { Backdrop } from "@mui/material";
import CircularLoader from "../../framework/CircularLoader";

const Loading = ({ open = false }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <CircularLoader variant="indeterminate" isProgress={false} />
    </Backdrop>
  );
};
export default Loading;
